<template>
  <div>
    <div class="trendBox" v-if="trendList.length > 0">
      <div class="header u-flex">
        <div  class="col_first" style="border-top: 0;">公司</div>
        <div class="headerTop u-flex-y u-flex-center">
          <div class="upstatus">胜负</div>
          <div class="downStatus u-flex u-flex-between">
            <span>主胜</span>
            <span>走势</span>
            <span>客胜</span>
          </div>
        </div>
        <div class="headerTop u-flex-y u-flex-center" >
          <div class="upstatus">让球</div>
          <div class="downStatus u-flex u-flex-around">
            <span>主胜</span>
            <span>走势</span>
            <span>客胜</span>
          </div>
        </div>
        <div class="headerTop u-flex-y u-flex-center">
          <div class="upstatus">进球数</div>
          <div class="downStatus u-flex u-flex-around">
            <span>大球</span>
            <span>走势</span>
            <span>小球</span>
          </div>
        </div>
        <div @click="testDemo(1)"  style="width: 70px; height: 76px;" class="lookMore u-flex u-flex-items-center u-flex-center">
          查看
        </div>
      </div>
      <div class="content_list u-flex" v-if="trendList.length > 0" v-for="(item,index) in trendList" :key="index">
        <div class="col_first">
            {{item.companyName}}
        </div>
        <div class="u-flex rightCont">
          <!-- 欧赔 -->
          <div class="headerTop u-flex-y" v-if="item.europeOddsVO">
            <div class="downStatus">
              <span >{{item.europeOddsVO.firstHomeOdds | tofix2(item.europeOddsVO.firstHomeOdds)}}</span>
              <span>{{item.europeOddsVO.firstFlatOdds | tofix2(item.europeOddsVO.firstFlatOdds)}}</span>
              <span>{{item.europeOddsVO.firstAwayOdds | tofix2(item.europeOddsVO.firstAwayOdds)}}</span>
            </div>
            <div class="downStatus" v-if="item.europeOddsVO.type == 3 && item.europeOddsVO.isEntertained ==2" >
               <span>封</span>
            </div>
            <div class="downStatus" v-else>
              <span  :class="{'redUp':item.europeOddsVO.homeUp ===2,'greenUp':item.europeOddsVO.homeUp ===1}">{{item.europeOddsVO.realHomeOdds | tofix2(item.europeOddsVO.realHomeOdds)}}
                <img style="height: 14px;width: 14px;" v-if="item.europeOddsVO.homeUp ==2" src="/static/scope/xia.png" alt="" srcset="">
                <img style="height: 14px;width: 14px;" v-if="item.europeOddsVO.homeUp ==1" src="/static/scope/shang.png" alt="" srcset="">
              </span>
              <span  :class="{'redUp':item.europeOddsVO.goalUp ===2,'greenUp':item.europeOddsVO.goalUp ===1}">{{item.europeOddsVO.realFlatOdds| tofix2(item.europeOddsVO.realFlatOdds)}}
                <img style="height: 14px;width: 14px;" v-if="item.europeOddsVO.goalUp ==2" src="/static/scope/xia.png" alt="" srcset="">
                <img style="height: 14px;width: 14px;" v-if="item.europeOddsVO.goalUp ==1" src="/static/scope/shang.png" alt="" srcset="">
              </span>
              <span  :class="{'redUp':item.europeOddsVO.awayUp ===2,'greenUp':item.europeOddsVO.awayUp ===1}">{{item.europeOddsVO.realAwayOdds | tofix2(item.europeOddsVO.realAwayOdds)}}
                <img style="height: 14px;width: 14px;" v-if="item.europeOddsVO.awayUp ==2" src="/static/scope/xia.png" alt="" srcset="">
                <img style="height: 14px;width: 14px;" v-if="item.europeOddsVO.awayUp ==1" src="/static/scope/shang.png" alt="" srcset="">
              </span>
            </div>
          </div>
          <div v-else  class="headerTop u-flex-y" >
            <div  class="downStatus">
                <span>-</span>
            </div>
          </div>
          <!-- 让球 -->
         <div  class="headerTop u-flex-y" v-if="item.asiaOddsVO">
           <div class="downStatus">
             <span>{{item.asiaOddsVO.firstHomeOdds | tofix2(item.asiaOddsVO.firstHomeOdds )}}</span>
             <span>{{item.asiaOddsVO.firstGoal | tofix2(item.asiaOddsVO.firstGoal )}}</span>
             <span>{{item.asiaOddsVO.firstAwayOdds | tofix2(item.asiaOddsVO.firstAwayOdds )}}</span>
           </div>
           <div class="downStatus" v-if="item.asiaOddsVO.type == 3 && item.asiaOddsVO.isEntertained ==2">
             <span>封</span>
           </div>
           <div class="downStatus" v-else>
             <span  :class="{'redUp':item.asiaOddsVO.homeUp ===2,'greenUp':item.asiaOddsVO.homeUp ===1}">{{item.asiaOddsVO.realHomeOdds| tofix2(item.asiaOddsVO.realHomeOdds )}}
               <img style="height: 14px;width: 14px;" v-if="item.asiaOddsVO.homeUp ==2" src="/static/scope/xia.png" alt="" srcset="">
               <img style="height: 14px;width: 14px;" v-if="item.asiaOddsVO.homeUp ==1" src="/static/scope/shang.png" alt="" srcset="">
             </span>
             <span  :class="{'redUp':item.asiaOddsVO.goalUp ===2,'greenUp':item.asiaOddsVO.goalUp ===1}">{{item.asiaOddsVO.realGoal | tofix2(item.asiaOddsVO.realGoal )}}
               <img style="height: 14px;width: 14px;" v-if="item.asiaOddsVO.goalUp ==2" src="/static/scope/xia.png" alt="" srcset="">
               <img style="height: 14px;width: 14px;" v-if="item.asiaOddsVO.goalUp ==1" src="/static/scope/shang.png" alt="" srcset="">
             </span>
             <span  :class="{'redUp':item.asiaOddsVO.awayUp ===2,'greenUp':item.asiaOddsVO.awayUp ===1}">{{item.asiaOddsVO.realAwayOdds| tofix2(item.asiaOddsVO.realAwayOdds )}}
               <img style="height: 14px;width: 14px;" v-if="item.asiaOddsVO.awayUp ==2" src="/static/scope/xia.png" alt="" srcset="">
               <img style="height: 14px;width: 14px;" v-if="item.asiaOddsVO.awayUp ==1" src="/static/scope/shang.png" alt="" srcset="">
             </span>
           </div>
         </div>
         <div v-else  class="headerTop u-flex-y" >
           <div  class="downStatus">
              <span>-</span>
           </div>
         </div>
         <!-- 大小球 -->
         <div  class="headerTop u-flex-y" v-if="item.bsOddsVO">
           <div class="downStatus">
             <span>{{item.bsOddsVO.firstUpOdds | tofix2(item.bsOddsVO.firstUpOdds ) }}</span>
             <span>{{item.bsOddsVO.firstGoal| tofix2(item.bsOddsVO.firstGoal ) }}</span>
             <span>{{item.bsOddsVO.firstDownOdds| tofix2(item.bsOddsVO.firstDownOdds ) }}</span>
           </div>
           <div class="downStatus" v-if="item.bsOddsVO.type == 3 && item.bsOddsVO.isEntertained ==2">
             <span>封</span>
           </div>
           <div class="downStatus" v-else>
             <span  :class="{'redUp':item.bsOddsVO.homeUp ===1,'greenUp':item.bsOddsVO.homeUp ===2}">{{item.bsOddsVO.realUpOdds | tofix2(item.bsOddsVO.realUpOdds )}}
             <img style="height: 14px;width: 14px;" v-if="item.bsOddsVO.homeUp ==1" src="/static/scope/xia.png" alt="" srcset="">
             <img style="height: 14px;width: 14px;" v-if="item.bsOddsVO.homeUp ==2" src="/static/scope/shang.png" alt="" srcset="">
             </span>
             <span  :class="{'redUp':item.bsOddsVO.goalUp ===1,'greenUp':item.bsOddsVO.goalUp ===2}">{{item.bsOddsVO.realGoal | tofix2(item.bsOddsVO.realGoal )}}
                  <img style="height: 14px;width: 14px;" v-if="item.bsOddsVO.goalUp ==1" src="/static/scope/xia.png" alt="" srcset="">
                  <img style="height: 14px;width: 14px;" v-if="item.bsOddsVO.goalUp ==2" src="/static/scope/shang.png" alt="" srcset="">
             </span>
             <span  :class="{'redUp':item.bsOddsVO.awayUp ===1,'greenUp':item.bsOddsVO.awayUp ===2}">{{item.bsOddsVO.realDownOdds  | tofix2(item.bsOddsVO.realDownOdds )}}
             <img style="height: 14px;width: 14px;" v-if="item.bsOddsVO.awayUp ==1" src="/static/scope/xia.png" alt="" srcset="">
             <img style="height: 14px;width: 14px;" v-if="item.bsOddsVO.awayUp ==2" src="/static/scope/shang.png" alt="" srcset="">
             </span>
           </div>
         </div>
         <div v-else  class="headerTop u-flex-y" >
           <div  class="downStatus">
            <span>-</span>
           </div>
         </div>
        </div>
        <div  style="width: 70px;" @click="navTo(item)" class="u-flex u-flex-items-center u-flex-center lookMore">
          <img style="height: 20px;width: 20px;" src="/static/scope/right.png" alt="" srcset="">
        </div>
      </div>
    </div>
       <div v-else class="noDatas">
         <img src="/static/dataimg/no_data.png" alt="" srcset="">
         <span>暂无数据</span>
       </div>

  </div>

</template>

<script>
  import {companyOddsCollectList} from '@/api/scope.js';
  import GlobalInfo from '@/lib/scoreSocket.js';
  export default {
    props:{
      matchId:{
        type:Number,
        default:'',
      },
    },
    data() {
      return {
        trendList:[]
      }
    },
    filters:{
      tofix2(val){
        if(val){
          return val.toFixed(2)
        }else{
          return '-'
        }
      }
    },
    created() {
      console.log('比赛id...',this.matchId);
      this.initData()
      // this.initGlobal()
    },
    methods:{
      testDemo(){

        //  亚盘 -让球
        // let val = {
        //       "changeTime": 1658778150, // 变盘时间
        //         "companyId": 95, // 公司ID
        //         "companyName": "盈禾",// 公司名称
        //         "firstAwayOdds": 0.91, // 初盘 - 客胜赔率
        //         "firstGoal": 1.5, // 初盘 - 盘口
        //         "firstHomeOdds": 0.85, // 初盘 - 主胜赔率
        //         "isEntertained": 2, // 是否封盘如为，1：默认，2：临时性封盘或停止走地
        //         "matchId": 64069, // 比赛ID
        //         "realAwayOdds": 0.91, // 即时(临场) - 客胜赔率
        //         "realGoal": 1.52, //  即时(临场) - 盘口
        //         "realHomeOdds": 0.95, //  即时(临场) - 主胜赔率

        //      // 下面三个字段不要接
        //         "timelyAwayOdds": 0, // 走地(赛中) - 客胜赔率
        //         "timelyGoal": 0, // 走地(赛中) - 盘口
        //         "timelyHomeOdds": 0, // 走地(赛中) - 主胜赔率

        //         "type": 2 // 【赔率类型】1：无类型数据 2：早餐盘(初盘), 3：临场盘(对应球探的赛前即时盘), 4：即时盘(对应球探的走地盘)
        // }
        // this.objectchange(val,1)

        // 大小球-进球数 2
        // let val = {
        //    "changeTime": 1658748203, // 变盘时间，单位：秒
        //      "companyId":  98, // 公司ID  98
        //      "companyName": "18bet", // 公司名称
        //      "firstDownOdds": 0.79, // 初盘 - 小球赔率
        //      "firstGoal": 2.75, // 初盘 - 盘口
        //      "firstUpOdds": 0.94, // 初盘 - 大球赔率
        //      "isEntertained": 1, // 是否封盘如为，1：默认，2：临时性封盘或停止走地
        //      "matchId": 64069, // 比赛ID
        //      "realDownOdds": 0.89, // 即时(临场) - 小球赔率
        //      "realGoal": 1.55,// 即时(临场) - 盘口
        //      "realUpOdds": 0.96,// 即时(临场) - 大球赔率
        //   // 下面三个字段不要接
        //      "timelyDownOdds": 0,
        //      "timelyGoal": 0,
        //      "timelyUpOdds": 0,

        //      "type": 2 // 【赔率类型】1：无类型数据 2：早餐盘（初盘）, 3：赛前即时盘, 4：走地盘
        // }



        // this.objectchange(val,2)


        // let val = {
        //     "changeTime": 1657475123, // 变盘时间，单位：秒
        //       "companyId": 98,// 公司ID
        //       "companyName": "盈禾",  // 公司名称
        //       "firstAwayOdds": 1.37, // 初盘 - 客胜赔率
        //       "firstFlatOdds": 4.51, // 初盘 - 平局赔率
        //       "firstHomeOdds": 5.8, // 初盘 - 主胜赔率
        //       "isEntertained": 1, // 是否封盘如为，1：默认，2：临时性封盘或停止走地
        //       "matchId": 64069, // 比赛ID
        //       "realAwayOdds": 1.37, // 即时(临场) - 客胜赔率
        //       "realFlatOdds": 4.51,// 即时(临场) - 平局赔率
        //       "realHomeOdds": 5.8,// 即时(临场) - 主胜赔率

        //   // 下面三个走地数据不要对接(暂时没有)
        //       "timelyAwayOdds": 0,
        //       "timelyFlatOdds": 0,
        //       "timelyHomeOdds": 0,

        //        "type": 2// 【赔率类型】1：无类型数据 2：早餐盘（初盘）, 3：赛前即时盘, 4：走地盘
        // }

        // this.objectchange(val,3)
      },
      async initGlobal() {
        console.log('这个页面是走势页的socket？');
        GlobalInfo.sucess = (e) => {
          console.log('这个页面是走势页的socket？');
          let Info = JSON.parse(e.data);
          switch (Info.messageType) {
            case 10001:
              console.log('比赛比分相关数据推送', Info.message);
              break;
            case 10002:
              console.log('比赛相关事件', Info.message);
              break;
            case 10003:
              console.log('比赛事件(删除错误的事件)', Info.message);
              break;
            case 10004:
              console.log('比赛角球事件', Info.message);
              break;
            case 10005:
              console.log(' 球队技术统计', Info.message);
              // this.objectchange(Info.message)
              break;
            case 10006:
              console.log(' 足球比赛(亚盘/让球)指数', Info.message);
              // this.objectchange(Info.message)
              this.objectchange(Info.message,1)
              break;
            case 10007:
              console.log(' 足球比赛(大小球)指数', Info.message);
              // this.objectchange(Info.message)
              this.objectchange(Info.message,2)
              break;
            case 10008:
              console.log(' 足球比赛(欧赔)指数', Info.message);
              this.objectchange(Info.message,3)
              break;
            default:
              break;
          }
        }
      },
      objectchange(val,state){
        if(state == 3){            // 欧赔

          console.log('数据合并3',val);
           this.trendList =  this.trendList.map(item =>{
             if(this.matchId == val.matchId && item.companyId == val.companyId){

               item.europeOddsVO.homeUp = 0
               item.europeOddsVO.awayUp = 0
               item.europeOddsVO.goalUp = 0

               if( item.europeOddsVO.realHomeOdds <  val.firstHomeOdds){
                 item.europeOddsVO.homeUp = 2
               }

               if( item.europeOddsVO.realHomeOdds >  val.firstHomeOdds){
                  item.europeOddsVO.homeUp = 1
               }

               if( item.europeOddsVO.realFlatOdds < val.firstFlatOdds){
                 item.europeOddsVO.goalUp = 2
               }

               if( item.europeOddsVO.realFlatOdds > val.firstFlatOdds){
                 item.europeOddsVO.goalUp = 1
               }

               if( item.europeOddsVO.realAwayOdds < val.firstAwayOdds){
                 item.europeOddsVO.awayUp = 2
               }

               if( item.europeOddsVO.realAwayOdds > val.firstAwayOdds){
                 item.europeOddsVO.awayUp = 1
               }


                item.europeOddsVO.realHomeOdds = val.firstHomeOdds
                item.europeOddsVO.realFlatOdds = val.firstFlatOdds
                item.europeOddsVO.realAwayOdds = val.firstAwayOdds
                item.europeOddsVO.type = val.type
                item.europeOddsVO.isEntertained = val.isEntertained
                console.log('合并结束3',item);
             }
             return item
           })
        }
        if(state == 2){     // 大小球-进球数
          console.log('数据合并2',val);
           this.trendList =  this.trendList.map(item =>{
             if(this.matchId == val.matchId && item.companyId == val.companyId){


               item.bsOddsVO.homeUp = 0
               item.bsOddsVO.awayUp = 0
               item.bsOddsVO.goalUp = 0

               if( item.bsOddsVO.realUpOdds >  val.realUpOdds){
                 item.bsOddsVO.homeUp = 2
               }

               if( item.bsOddsVO.realUpOdds <  val.realUpOdds){
                  item.bsOddsVO.homeUp = 1
               }

               if( item.bsOddsVO.realGoal > val.realGoal){
                 item.bsOddsVO.goalUp = 2
               }

               if( item.bsOddsVO.realGoal < val.realGoal){
                 item.bsOddsVO.goalUp = 1
               }

               if( item.bsOddsVO.realDownOdds > val.realDownOdds){
                 item.bsOddsVO.awayUp = 2
               }

               if( item.bsOddsVO.realDownOdds < val.realDownOdds){
                 item.bsOddsVO.awayUp = 1
               }





                item.bsOddsVO.realUpOdds = val.realUpOdds;
                item.bsOddsVO.realGoal = val.realGoal;
                item.bsOddsVO.realDownOdds = val.realDownOdds;

                item.bsOddsVO.type = val.type
                item.bsOddsVO.isEntertained = val.isEntertained

                console.log('合并结束2',item);
             }

             return item
           })
        }
        if(state == 1){     // 亚盘-让球
          console.log('数据合并1',val);
           this.trendList =  this.trendList.map(item =>{
             if(this.matchId == val.matchId && item.companyId == val.companyId){


               item.asiaOddsVO.homeUp = 0
               item.asiaOddsVO.awayUp = 0
               item.asiaOddsVO.goalUp = 0

               if( item.asiaOddsVO.realHomeOdds <  val.realHomeOdds){
                 item.asiaOddsVO.homeUp = 2
               }

               if( item.asiaOddsVO.realHomeOdds >  val.realHomeOdds){
                  item.asiaOddsVO.homeUp = 1
               }

               if( item.asiaOddsVO.realGoal < val.realGoal){
                 item.asiaOddsVO.goalUp = 2
               }

               if( item.asiaOddsVO.realGoal > val.realGoal){
                 item.asiaOddsVO.goalUp = 1
               }

               if( item.asiaOddsVO.realAwayOdds < val.realAwayOdds){
                 item.asiaOddsVO.awayUp = 2
               }

               if( item.asiaOddsVO.realAwayOdds > val.realAwayOdds){
                 item.asiaOddsVO.awayUp = 1
               }


                item.asiaOddsVO.realHomeOdds = val.realHomeOdds;
                item.asiaOddsVO.realGoal = val.realGoal;
                item.asiaOddsVO.realAwayOdds = val.realAwayOdds;

                item.asiaOddsVO.type = val.type
                item.asiaOddsVO.isEntertained = val.isEntertained

                console.log('合并结束1',item);
             }
             return item
           })
        }
        this.$forceUpdate()
      },
      navTo(item){
         const neww = this.$router.resolve({
            path: "/scopeDetails",
            query: { rid: 2,matchId:this.matchId,companyId:item.companyId },
          });
          window.open(neww.href, "_self");
      },
      initData(){
        companyOddsCollectList({
          matchId:this.matchId,
        }).then(res=>{
          if(res.data.code == 200){
            console.log('走势数据',res.data.data);
            this.trendList = res.data.data;
            this.trendList.map(item=>{
              item.companyName = item.companyName.slice(0,1) + '**'
            })
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../assets/style/flex.scss';
  .col_first{
    width: 140px;
    height: 76px;
    text-align: center;
    line-height: 76px;
    border-top: 1px solid rgba(0,0,0,.0);
    border-right: 1px solid rgba(0,0,0,.1);
    border-bottom: 1px solid rgba(0,0,0,.1);
  }
  .redUp {
    color: red !important;
  }

  .greenUp {
    color: green !important;
  }
  .lookMore{
    cursor: pointer;
    border-bottom: 1px solid rgba(0,0,0,.1);
  }
  .content_list{
    display: flex;

    .rightCont{
      flex: 2;
      display: flex;
      justify-content: space-between;
      .headerTop {
        flex: 1;
        .downStatus {
          flex: 1;
          width: 100%;
          border-bottom: 1px solid rgba(0,0,0,.1);
          display: flex;
          justify-content: space-between;
          span{
            display: flex;
            flex: 1;
            justify-content: center;
            align-items: center;
            line-height: 38px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
         }
        }
      }
    }
  }
  .noDatas{
    width: 100%;
    display: flex;
    justify-content: center;
    padding:50px 0;
    flex-direction: column;
    align-items: center;
    span{
     margin-top: 20px;
     font-size: 14px;
     color: #999999;
    }
    img{
      width: 189px;
      height: 238px;
    }
  }
  .trendBox{
    border: 1px solid rgba(0,0,0,.1);
    border-bottom: none;
    background-color: #fff;
    .header{
      background-color: #F6F0FF;
    }
    .headerTop{
      border-right: 1px solid rgba(0,0,0,.1);
      .downStatus{
        height: 38px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        border-bottom: 1px solid rgba(0,0,0,.1);
        span{
          flex: 1;
          text-align: center;
          line-height: 38px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
        }
      }
      .upstatus{
        width: 330px;
        height: 38px;
        text-align: center;
        line-height: 38px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/components/lz_trend.vue